module.exports = new __parcel__URL__("asterisk.385f948c.webp").toString();